import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ProductManual from './pages/ProductManual';
import Portal from './pages/Portal';
import MarketingChildren from './pages/Marketing/Children';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/zh/manual" element={<ProductManual />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/marketing" element={<MarketingChildren />} />
      </Routes>
    </Router>
  );
}

export default App;
